import React from 'react'

import { getMediaUrl } from '../../utils/helpers'

import Image from './Image'

interface UsersGroupProps {
    list: {
        src: string
    }[]
    usersCount: number
}

const UsersGroup = ({ list, usersCount }: UsersGroupProps) => {
    const firstThreeUsers = list.slice(0, 3)
    return (
        <div className="user-list-group">
            <ul className="user-list">
                {firstThreeUsers.map((el, index) => (
                    <li key={index}>
                        <div className="user-28x28">
                            <Image
                                src={getMediaUrl(el.src)}
                                width={28}
                                height={28}
                            />
                        </div>
                    </li>
                ))}
            </ul>
            <span className="user-cunter">
                {usersCount - 3 > 0 && `+${usersCount - 3}`}
            </span>
        </div>
    )
}

export default UsersGroup
